/* eslint-disable no-undef */
(function () {
  'use strict';

  window.OletLens = window.OletLens || {};

  var Config = window.OletLens.Config || {};
  var Utils = window.OletLens.Utils || {};

  function getFrameVariantId() {
    var input = document.querySelector('input[name="id"].product-variant-id');
    if (!input) {
      var productPrice = document.getElementById('product-price');
      if (productPrice) {
        var variantParam = new URLSearchParams(window.location.search).get('variant');
        if (variantParam) return Number(variantParam);
      }
      return null;
    }
    return Number(input.value) || null;
  }

  function buildCartPayload(state, frameVariantId, config) {
    var usageType = state.usage || 'single_vision';
    var tier = state.lensType || 'basic';
    var selectedLensVariantId = state && state.lensVariantId ? Number(state.lensVariantId) : null;
    var lensBaseVariantId = selectedLensVariantId || Utils.resolveVariantId(usageType, tier);

    var disallowed =
      typeof Utils.getDisallowedAddonKeys === 'function'
        ? Utils.getDisallowedAddonKeys(usageType, tier, lensBaseVariantId)
        : [];

    if (!frameVariantId || !lensBaseVariantId) {
      return { items: [] };
    }

    var bundleKey = Utils.generateBundleKey(frameVariantId);
    var PROPS = config.PROPS;
    var ROLES = config.BUNDLE_ROLES;

    var rxJson = {};
    var rxMethod = 'manual';

    if (usageType === 'reading') {
      var rd = state.reading || {};
      rxJson = {
        person_name: rd.person_name || '',
        reading_strength: rd.strength || '',
        pd: rd.pd || {},
      };
    } else if (usageType === 'non-prescription') {
      rxJson = { non_prescription: true };
    } else {
      var rx = state.prescription || {};
      var isUploadRx =
        state.rxMethod === 'upload' ||
        !!(state.rxFileUrl && String(state.rxFileUrl).trim()) ||
        !!(state.rxFilePreview && String(state.rxFilePreview).trim());

      if (isUploadRx) {
        rxJson = {
          person_name: rx.person_name || '',
          pd: rx.pd || {},
          comments: rx.comments || '',
        };
        rxMethod = 'upload';
      } else {
        rxJson = {
          person_name: rx.person_name || '',
          od: rx.od || {},
          os: rx.os || {},
          pd: rx.pd || {},
          comments: rx.comments || '',
          hasPrism: rx.hasPrism || false,
          prism: rx.prism || null,
        };
      }
    }

    var items = [];
    var usageLabelMap = {
      single_vision: 'Single Vision',
      progressives: 'Progressives',
      bifocals: 'Bifocals',
      reading: 'Reading',
      'non-prescription': 'Non-Prescription',
    };
    var usageLabel = usageLabelMap[usageType] || usageType;
    var rxMethodLabelMap = {
      manual: 'Prescription details added',
      upload: 'Uploaded prescription file attached',
      later: 'Prescription to be provided later',
    };
    var rxMethodLabel = rxMethodLabelMap[rxMethod] || rxMethod;

    var framePropObj = {};
    framePropObj[PROPS.BUNDLE_KEY] = bundleKey;
    framePropObj[PROPS.BUNDLE_ROLE] = ROLES.FRAME;
    items.push({ id: frameVariantId, quantity: 1, properties: framePropObj });

    var lensPropObj = {};
    lensPropObj[PROPS.BUNDLE_KEY] = bundleKey;
    lensPropObj[PROPS.BUNDLE_ROLE] = ROLES.LENS_BASE;
    lensPropObj[PROPS.USAGE_TYPE] = usageType;
    lensPropObj[PROPS.RX_METHOD] = rxMethod;
    lensPropObj[PROPS.RX_JSON] = JSON.stringify(rxJson);
    lensPropObj[PROPS.RX_FILE_URL] = state.rxFileUrl || '';
    // Customer-friendly checkout fields (non-sensitive)
    lensPropObj['Lens Type'] = usageLabel;
    lensPropObj['Prescription'] = rxMethodLabel;
    if (rxMethod === 'upload' && state.rxFileUrl) {
      lensPropObj['Prescription File'] = state.rxFileUrl;
    }
    items.push({ id: lensBaseVariantId, quantity: 1, properties: lensPropObj });

    (state.addons || []).forEach(function (addonKey) {
      var normKey = Utils.normalizeSunglassesAddonKey ? Utils.normalizeSunglassesAddonKey(addonKey) : addonKey;
      if (disallowed.indexOf(normKey) !== -1) return;
      var addonId = Utils.resolveAddonVariantId(addonKey);
      if (!addonId) return;
      var addonPropObj = {};
      addonPropObj[PROPS.BUNDLE_KEY] = bundleKey;
      addonPropObj[PROPS.BUNDLE_ROLE] = ROLES.ADDON;
      items.push({ id: addonId, quantity: 1, properties: addonPropObj });
    });

    var sunNorm =
      state.sunglasses && Utils.normalizeSunglassesAddonKey
        ? Utils.normalizeSunglassesAddonKey(state.sunglasses)
        : state.sunglasses;
    if (state.sunglasses && disallowed.indexOf(sunNorm) === -1) {
      var sunId = Utils.resolveAddonVariantId(state.sunglasses);
      if (sunId) {
        var sunPropObj = {};
        sunPropObj[PROPS.BUNDLE_KEY] = bundleKey;
        sunPropObj[PROPS.BUNDLE_ROLE] = ROLES.ADDON;
        sunPropObj._addon_color = state.sunglassesColor || '';
        items.push({ id: sunId, quantity: 1, properties: sunPropObj });
      }
    }

    return { items: items };
  }

  function addBundleToCart(payload) {
    if (!payload || !payload.items || !payload.items.length) {
      return Promise.reject(new Error('Empty payload'));
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart API error: ' + response.status);
      return response.json();
    });
  }

  function removePreviousBundle(frameVariantId, bundleKey) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var updates = {};
        var keyProp = Config.PROPS.BUNDLE_KEY;

        if (bundleKey != null && String(bundleKey).trim() !== '') {
          var bk = String(bundleKey).trim();
          cart.items.forEach(function (inner) {
            if (inner.properties && inner.properties[keyProp] === bk) {
              updates[inner.key] = 0;
            }
          });
        } else {
          var frameVid = frameVariantId != null ? Number(frameVariantId) : NaN;
          cart.items.forEach(function (item) {
            if (Number.isNaN(frameVid) || Number(item.variant_id) !== frameVid) return;

            var itemBundleKey = item.properties && item.properties[keyProp];
            if (itemBundleKey) {
              cart.items.forEach(function (inner) {
                if (inner.properties && inner.properties[keyProp] === itemBundleKey) {
                  updates[inner.key] = 0;
                }
              });
            } else {
              updates[item.key] = 0;
            }
          });
        }

        if (Object.keys(updates).length === 0) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        });
      });
  }

  function uploadPrescriptionFile(fileData) {
    if (!fileData) return Promise.resolve(null);
    return fetch(Config.API_BASE_URL + '/api/prescriptions/upload', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ file: fileData }),
    }).then(function (response) {
      if (!response.ok) throw new Error('Upload failed');
      return response.json();
    }).then(function (json) {
      return json && json.url ? json.url : null;
    });
  }

  function loadPreviousRx(customerId) {
    if (!customerId) return Promise.resolve(null);
    var url = Config.API_BASE_URL + '/api/lens-orders/last?shopify_customer_id=' + encodeURIComponent(String(customerId));
    return fetch(url, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (json) {
        return json && json.data ? json.data : null;
      });
  }

  window.OletLens.CartSubmission = {
    getFrameVariantId: getFrameVariantId,
    buildCartPayload: buildCartPayload,
    addBundleToCart: addBundleToCart,
    removePreviousBundle: removePreviousBundle,
    uploadPrescriptionFile: uploadPrescriptionFile,
    loadPreviousRx: loadPreviousRx,
  };
})();
